(function () {
  function softenOptionBorders() {
    document.querySelectorAll('.lw-product-showcase .lw-value-btn').forEach(function (button) {
      button.classList.add('lw-soft-option-border');
      button.style.setProperty('border', '1px solid #222', 'important');
      button.style.setProperty('box-shadow', 'none', 'important');
      button.style.setProperty('outline', '0', 'important');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', softenOptionBorders);
  } else {
    softenOptionBorders();
  }

  document.addEventListener('shopify:section:load', softenOptionBorders);
  document.addEventListener('click', function (event) {
    if (event.target.closest('.lw-value-btn')) {
      window.requestAnimationFrame(softenOptionBorders);
    }
  });
})();
